import { useReducer } from 'react';

const useAuthnReducer = () => {
  const [state, dispatch] = useReducer(
    (_, action) => {
      switch (action) {
        case 'LOGIN':
          return {
            open: true,
            state: 'login',
          };
        case 'MODIFY':
          return {
            open: true,
            state: 'modify',
          };
        case 'WRITE':
          return {
            open: false,
            state: 'wrtie',
          };
        case 'CLOSE':
          return {
            open: false,
            state: '',
          };
        default:
          throw new Error(`Unhandled action type: ${action}`);
      }
    },
    {
      open: false,
      state: '',
    }
  );

  if (state.open) document.body.style.overflow = 'hidden';
  else document.body.style.overflow = '';

  return [state, dispatch];
};

export default useAuthnReducer;
